module.exports = __webpack_public_path__ + "img/39_26.6e8f1941.png";